<template>
  <div>
    <div class="section-wrapper">
      <v-container class="related-news-section" grid-list-lg fluid>
      <div class="section-icon__wrapper">
        <i class="fas fa-newspaper section-icon__icon"></i>
      </div>

      <v-layout justify-center align-center row wrap>
        <v-flex xs12 flexbox>
            <slot name="title">
              <div class="section-title__wrapper">
                  <span class="section-title__title">
                    {{ title }}
                  </span>
                  <v-btn large outline color="white" :to="{name: 'actus'}"><i class="far fa-eye btn-icon"></i>{{ linkName }}</v-btn>
              </div>
            </slot>
        </v-flex>
        <v-layout align-start justify-center row wrap>
          <v-flex  xs12 sm6 md4 lg3 v-for="item in requestNews" :key="item.id" justify-center class="mt-5 ">
            <app-related-news-card
            class="related-card-wrapper"
            :article="item"
            :tagColor="getCategoryColor(item.acf.categorie.term_id)"></app-related-news-card>
          </v-flex>
        </v-layout>

      </v-layout>
    </v-container >
    </div>

  </div>
</template>

<script>
import RelatedNewsCard from "./RelatedNewsCard.vue";

import axios from 'axios';
import {_} from 'underscore';

import RestApiHelper from "../../../helpers/rest-api-func.js";
import { RestPageIdx, RestCustomPosts, WP_API_ACF_ROOT_URL, WP_API_WP_ROOT_URL } from '../../../helpers/rest-api-addr.js';

export default {
  data() {
    return {
      requestNews: [],
      requestCategories: [],
      isLoadingData: false,
      nbPostsDefault: 3
    };
  },
  props: {
    title: {type: String, default: "Dernières actus du BOP"},
    linkName: {type: String, default: "Toute l'actualité"},
    nbActus: {type: [Boolean, Number], default: 3},
    categories: {type: [Array, Boolean], default: function() {return []; }},
    teams: {type: [Array, Boolean], default: function() {return []; }},
  },
  mounted() {
    this.debouncedLoad = _.debounce(this.loadArticles, 500, true);
    this.loadArticles();
  },
  watch: {
      categories: function(newCategories, oldCategories) {
      this.categories = newCategories;
      this.debouncedLoad();
    }
  },
  methods: {
    loadArticles() {
      let cat = this.categories ? this.categories : [];
      this.isLoadingData = true;
      let nbPosts = this.nbActus ? this.nbActus : this.nbPostsDefault;
      let self = this;

      // requete de nouveaux liens.
      RestApiHelper.requestCustomPostData(
              WP_API_WP_ROOT_URL,
              RestApiHelper.postsEndpoint,
              this.categories)
      axios.all([
            RestApiHelper.requestPosts(WP_API_WP_ROOT_URL, nbPosts, 1, cat),
            RestApiHelper.requestPostsCat(WP_API_WP_ROOT_URL, nbPosts, 1, cat),
            RestApiHelper.requestTaxo(WP_API_ACF_ROOT_URL, 'categories')
          ])
      .then(axios.spread( function(r_data_no_cat, r_data_cat, r_categories) {
        // sauvegarde des données dans des variables user-friendly (au moins)
        let data_cat = r_data_cat.data;
        let data_no_cat = r_data_no_cat.data;

        let data = data_cat.splice(0, nbPosts);
        if(data.length < nbPosts) {
          data.push(data_no_cat.splice(0, nbPosts - data.length))
        }

        data = _.flatten(data);

        self.setData(data, r_categories.data, false);
      }))
      .catch(error => {
        self.setData(null, null, false);
      });
    },
    setData(data, categoriesData, isLoading) {
      this.requestNews = data ? data : [];
      this.requestCategories = categoriesData ? categoriesData : [];
      this.$nextTick(function() {
        this.isLoadingData = isLoading;
      });
    },
    getCategoryColor(id) {
      let cat_item = _.find(this.requestCategories, function(item) {
        return item.id == id;
      });

      let color = "rgba("+this.hexToRgb(cat_item.acf.color)+",0.90)";
      return color;
    },
    hexToRgb(colorHex) {
      let hex = colorHex.slice(1);
      let r = parseInt(hex[0]+hex[1],16);
      let g = parseInt(hex[2]+hex[3],16);
      let b = parseInt(hex[4]+hex[5],16);

      return (r+","+g+","+b);
    }
  },
  components: {
    "app-related-news-card": RelatedNewsCard
  }
};
</script>

<style lang="scss">
// .section-wrapper {
//   position: relative;
//   display: block;
//   width: 100%;
//   height: auto;
//   margin-top: 60px;
//   background-color: red;
// }

.related-card-wrapper > * {
  height: 100%;
}
.related-news-section {
  position: relative;
  // background-color: #006cbc;
  $color-bg-dark: rgba(14,28,52, 1); // #0087b8;
  $color-percent-plus: 4%;
 background: /*url("/static/assets/texture/inspiration-geometry.png") repeat,*/
  linear-gradient(135deg, $color-bg-dark   60%, lighten($color-bg-dark, $color-percent-plus) 20%);
  margin-top: 60px;
  border-top: 5px solid white;
  padding-bottom: 80px;

  & .section-icon {
    &__wrapper {
      position: absolute;
      display: block;
      top: -40px;
      left: 50%;
      transform: translateX(-50%);
      width: 80px;
      height: 80px;
      font-size: 2rem;
      color: white;
      // background-color: #0087b8;// #006cbc;
      background-color: $color-bg-dark;
      border-radius: 100%;
      border: 5px solid white;
      text-align:center;
      z-index: 1;
      box-sizing: content-box;
    }

    &__icon {
      position: relative;
      display: flex;
      justify-content: center;
      align-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      font-size: 3rem;
      color: white;
      border-radius: 100%;
      border-color: 3px solid white;
    }
  }

  & .section-title {
    &__wrapper {
      position: relative;
      display: block;
      text-align: center;
      color: white;
      margin-top: 50px;

      // background-color: rgba(#eee, 0.1);

      & .btn-icon {
        padding-right: 10px;
      }
    }

    &__title {
      position: relative;
      font-size: 2rem;
      display: block;
      margin-bottom: 40px;

      &::before {
        content:" ";
        display:block;
        position: absolute;
        height: 2px;
        width: 100px;
        bottom: -20px;
        left: 50%;
        transform: translateX(-50%);
        background-color: white;
      }
    }


  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/shared/RelatedNewsSection.vue